import { modelOptions, prop } from '@typegoose/typegoose';
import mongoose from 'mongoose';
import { AffectedUser, ScoreBreakdown } from './riskManagement.common.model';

@modelOptions({
  schemaOptions: { collection: 'companyHumanRiskState' },
  options: { customName: 'companyHumanRiskState' },
})
export class CompanyHumanRiskStateModel {
  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true, type: ScoreBreakdown })
  scoreBreakdown: ScoreBreakdown;

  @prop()
  indicatorId: number;

  @prop()
  state: number;

  @prop()
  operatingSystem: number;

  @prop({ required: true, type: AffectedUser })
  affectedUsers: Array<AffectedUser>;
}
